



window.DEV = {

	enable : false,
	cursorElem : null,

	once(){

		//
		$html.classList.add('is-dev');

		//
		document.addEventListener( 'keydown', (event) => {
			if (event.key === '8' || event.keyCode === 56) {
				$html.classList.add('is-capture-before');
				setTimeout(()=>{
					$html.classList.remove('is-capture-before');
					pageScroll.onAutoScroll();
				},500);
			}
		});

		//
		if( getParam('cursor') ){
			this.cursorElem = document.createElement('div');
			this.cursorElem.classList.add('js-dev-cursor');
			document.body.appendChild( this.cursorElem );
			switch( getParam('cursor') ){
				case 'pointer':
					$html.classList.add('is-cursor-pointer');		
				break;
				case 'hide':
					$html.classList.add('is-cursor-hide');		
				break;
			}
		}

		//
		if( getParam('removeLink') ){
			const $a = document.querySelectorAll('a');
			for (let i = 0; i < $a.length; i++) {
				const el = $a[i];
				el.removeAttribute('href');
			}
		}

		//
		this.enable = true;

	},

	onMouseMove(){

		if( !this.enable ) return false;
		if( this.cursorElem && styleMouse.body.array[2] ){
			const x = styleMouse.body.array[2].delta.x;
			const y = styleMouse.body.array[2].delta.y;
			this.cursorElem.style.transform = `translate3d(${x}px,${y}px,0px)`;
		}

	}

}

if( getParam('autoScrollSpeed') || getParam('cursor') || getParam('removeLink') ){
	DEV.once();
}











